import CircularNode from './CircularNode';
import ExpandableNode from './ExpandableNode';
import TurboNode from './components/nodes/TurboNode';
import SwitchNode from './components/nodes/SwitchNode';
import ConditionNode from './components/nodes/ConditionNode';

export const nodeTypes = {
  circularNode: CircularNode,
  Model: TurboNode,
  Arithmetic: TurboNode,
  Service: TurboNode,
  Condition: ConditionNode,
  Switch: SwitchNode,
  input: TurboNode,
  Scenario: TurboNode,
  For: ExpandableNode,
  Loop: ExpandableNode,
  Eq: TurboNode,
  Not: TurboNode,
  And: TurboNode,
  Or: TurboNode,
  Xor: TurboNode,
  ProgramCall: TurboNode,
  MetinselIslemler: TurboNode,
  Email: TurboNode,
  SMS: TurboNode,
  PLCCommand: TurboNode,
  RisingEdge: TurboNode,
  Alarm: TurboNode,
};

